import { AuditTimeline } from '../../../shared/features/history/components/AuditTimeline';
import { useHistory } from '../../../shared/features/history/hooks/use-history';

/** A job's whole history: field edits and state transitions are all audited against `entityType: 'job'`. */
export function JobHistoryTab({ jobId }: { jobId: string }) {
  const state = useHistory('job', jobId, true);
  return <AuditTimeline state={state} />;
}
